import { BasicCard, CardContent, CardDescription, CardHeader } from "./styles";
import { projectPath } from "common/src/routes/explorer";
import { ProjectBanner, ProjectLogo } from "./ProjectBanner";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ProjectCard(props) {
  var _project$metadata$ban;
  const {
    project
  } = props;
  return /*#__PURE__*/_jsx(BasicCard, {
    className: "w-full hover:opacity-90 transition hover:shadow-none",
    children: /*#__PURE__*/_jsxs("a", {
      target: "_blank",
      href: projectPath({
        projectId: project.id
      }),
      "data-track-event": "project-card",
      children: [/*#__PURE__*/_jsx(CardHeader, {
        className: "relative",
        children: /*#__PURE__*/_jsx(ProjectBanner, {
          bannerImgCid: (_project$metadata$ban = project.metadata.bannerImg) !== null && _project$metadata$ban !== void 0 ? _project$metadata$ban : null,
          classNameOverride: "bg-black h-[120px] w-full object-cover rounded-t",
          resizeHeight: 120
        })
      }), /*#__PURE__*/_jsxs(CardContent, {
        className: "relative",
        children: [project.metadata.logoImg !== undefined && /*#__PURE__*/_jsx(ProjectLogo, {
          className: "border-solid border-2 border-white absolute -top-[24px] ",
          imageCid: project.metadata.logoImg,
          size: 48
        }), /*#__PURE__*/_jsx("div", {
          className: "truncate mt-4",
          children: project.name
        }), /*#__PURE__*/_jsx(CardDescription, {
          className: " min-h-[96px]",
          children: /*#__PURE__*/_jsx("div", {
            className: "text-sm line-clamp-4",
            children: project.metadata.description
          })
        })]
      })]
    })
  });
}